import Vue from 'vue'
import App from './App.vue'
import DownloadApp from './downloadApp/DownloadApp.vue'
//import VirtualShopper from './virtualShopper/VirtualShopper.vue'
import './assets/css/main.css'
import vuetify from './plugins/vuetify'
import { store } from './store/store' 
import 'material-design-icons-iconfont/dist/material-design-icons.css'
import VueCustomTooltip from '@adamdehaven/vue-custom-tooltip'
import VModal from 'vue-js-modal'

Vue.config.devtools = true
Vue.use(VModal)
Vue.use(VueCustomTooltip, {
  name: 'VueCustomTooltip',
  color: '#fff',
  background: '#000',
  borderRadius: 0,
  fontWeight: 400,
})

new Vue({
  store: store,
  vuetify,
  render: h => h(App),
}).$mount('#app_prod')



new Vue({
  store: store,
  vuetify,
  render: h => h(DownloadApp),
}).$mount('#download_app')


//Vue.prototype.ZoomMtg = window.ZoomMtg;

//new Vue({
//  store: store,
//  vuetify,
//  render: h => h(VirtualShopper),
//}).$mount('#virtual_shopper')